export const errorHandler = (error) => {
  let errorString = '';
  if (!error?.response?.status) {
    return error?.decline_code? error.decline_code : error?.code? error.code : error?.message
  }
  switch (error?.response?.status) {
    case 500:
      return 'Internal_Server_Error';
    case 400:
      if (error?.response?.data?.errors) {
        for (const [value] of Object.entries(error.response.data.errors)) {
          errorString += (error?.response?.data?.errors?.[value]?.join() || value) + ' ';
        }
      } else {
        for (const [value] of Object.entries(error.response.data)) {
          errorString += (error?.response?.data?.[value]?.join() || value) + ' ';
        }
      }

      return errorString;
    case 402:
      return '402_error'
    default:
      return  error?.decline_code? error.decline_code : error?.code? error.code : error?.response?.message || error?.message
  }
}
